// extracted by mini-css-extract-plugin
export var active = "_2s-d";
export var blink = "_2s-e";
export var container = "_2s-5";
export var controls = "_2s-0";
export var controlsRight = "_2s-1";
export var fakeCursor = "_2s-c";
export var hidden = "_2s-b";
export var quillContainerSmall = "_2s-7";
export var quillEditor = "_2s-6";
export var quillEditorSmall = "_2s-8";
export var quillFormatButtons = "_2s-a";
export var quillToolbar = "_2s-9";
export var removePadding = "_2s-2";
export var state = "_2s-3";
export var stateTitle = "_2s-4";